/**
 * Shared loading-spinner copy (captions + aria labels).
 * Used by ProtectedRoute, lazy routes, and in-app surfaces that should match the same messaging.
 * Single map for product review and future i18n (e.g. swap with t('protectedRoute.restoringSession')).
 */
export const PROTECTED_ROUTE_LOADING_COPY = {
  restoringSession: 'Restoring session…',
  signingOut: 'Signing out…',
  validatingAccount: 'Validating your account…',
  authenticating: 'Authenticating…',
  checkingAuthentication: 'Checking authentication…',
  checkingLicenseStatus: 'Checking license status…',
  verifyingLicenseStatus: 'Verifying license status…',
  verifyingAccess: 'Verifying access…',
  loadingPage: 'Loading page…',
  /** Generic in-page data loading (e.g. provider-approvals table). */
  loading: 'Loading…',
} as const;

export type ProtectedRouteLoadingCopyKey = keyof typeof PROTECTED_ROUTE_LOADING_COPY;
